// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2I50A","left":"StickyBox_left__3UeZt","right":"StickyBox_right__3kDJO"};